import React from "react";
import { bool, number, string } from "prop-types";
import { Paper } from "@mui/material";
import ProgressIndicator from "./ProgressIndicator";

const WrappedProgressIndicator = ({ loading, id = "", elevation = 0, minHeight = 500 }) => (
  <Paper id={id} elevation={elevation} style={{ minHeight: `${minHeight}px` }}>
    <ProgressIndicator active={loading} />
  </Paper>
);

WrappedProgressIndicator.propTypes = {
  loading: bool.isRequired,
  id: string,
  elevation: number,
  minHeight: number,
};

export default WrappedProgressIndicator;
